<div
  class="c-section__wrapper"
  [ngClass]="{
    'c-section__wrapper--gray': gray,
    'c-section__wrapper--no-header': noHeader,
    'c-section__wrapper--flame': flame
  }"
>
  <div *ngIf="showPastDueBanner" class="banner">
    <div class="banner-content">
      <span i18n="@@bannerContent"
        >Pay the invoice sent to your email to keep your account active. For
        questions about billing,</span
      >
      &nbsp;<a [routerLink]="['/support/dashboard']" i18n="@@contactSupport"
        >contact Support</a
      >.
    </div>
  </div>
  <ls-flash></ls-flash>
  <div [ngClass]="useGrid ? 'o-layout-g' : noLayout ? '' : 'o-layout'">
    <div class="o-layout__block u-layout-column u-layout-full u-width-100">
      <ng-content #content></ng-content>
    </div>
  </div>
</div>
